import financialInvestmentDisclaimer from '../../../docs/legal/financial-investment-disclaimer.md?raw';
import marketDataDisclaimer from '../../../docs/legal/market-data-disclaimer.md?raw';
import paperTradingDisclaimer from '../../../docs/legal/paper-trading-disclaimer.md?raw';
import privacyPolicy from '../../../docs/legal/privacy-policy.md?raw';
import refundPolicy from '../../../docs/legal/refund-policy.md?raw';
import subscriptionPolicy from '../../../docs/legal/subscription-policy.md?raw';
import termsOfService from '../../../docs/legal/terms-of-service.md?raw';

export type LegalDoc = {
  slug: string;
  label: string;
  summary: string;
  source: string;
};

export const legalDocs: LegalDoc[] = [
  {
    slug: 'privacy-policy',
    label: 'Privacy Policy',
    summary: 'What we collect, how we use it, how long we keep it, and your rights.',
    source: privacyPolicy,
  },
  {
    slug: 'terms-of-service',
    label: 'Terms of Service',
    summary: 'The agreement between you and Ascensa for using the app and website.',
    source: termsOfService,
  },
  {
    slug: 'subscription-policy',
    label: 'Subscription Policy',
    summary: 'How Ascensa Plus billing, renewal, and cancellation work.',
    source: subscriptionPolicy,
  },
  {
    slug: 'refund-policy',
    label: 'Refund Policy',
    summary: 'Who handles refunds for App Store and Google Play purchases.',
    source: refundPolicy,
  },
  {
    slug: 'financial-investment-disclaimer',
    label: 'Financial & Investment Disclaimer',
    summary: 'Why Ascensa is research software and never investment advice.',
    source: financialInvestmentDisclaimer,
  },
  {
    slug: 'market-data-disclaimer',
    label: 'Market Data Disclaimer',
    summary: 'How current our prices, fundamentals, and news are — and are not.',
    source: marketDataDisclaimer,
  },
  {
    slug: 'paper-trading-disclaimer',
    label: 'Paper Trading Disclaimer',
    summary: 'Practice portfolios are simulated and use stored closing prices.',
    source: paperTradingDisclaimer,
  },
];

export const legalBySlug = new Map(legalDocs.map((doc) => [doc.slug, doc]));
